export default "__VITE_ASSET__CiDCbrvh__"